
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.667.833c.055 0 .11.007.163.021a21 21 0 0010.34 0 .667.667 0 01.82.533l.666 3.8a.667.667 0 01-.4.734c-1.01.433-1.958 1-2.818 1.686a7.188 7.188 0 00-1.63 2.17.667.667 0 01-.608.394H5.8a.667.667 0 01-.61-.396 7.187 7.187 0 00-1.63-2.169A12.25 12.25 0 00.744 5.919a.667.667 0 01-.4-.733l.666-3.8a.667.667 0 01.658-.553zm5.333 2a24.846 24.846 0 01-4.8-.53l-.457 2.6a12.508 12.508 0 012.694 1.692 8.46 8.46 0 011.769 2.236h1.583a8.46 8.46 0 011.77-2.236 12.506 12.506 0 012.693-1.692l-.457-2.6c-1.577.332-3.183.51-4.795.53z"}})])
          )
        }
      }
    